module.exports = __webpack_public_path__ + "img/key.59bf2cc3.png";